<template>
  <div :class="isAtTop ? 'ProductList' : 'ProductList dets_body'">
    <Header />
    <div class="site_banner bg-cover" :style="{ backgroundImage: `url(${basicInfo.productListBanner})` }">
      <img :src="basicInfo.productListBanner" alt="" />
      <!-- <img src="https://www.masslinkzl.com/upload/image/20260504/d1cf7baa-ad73-4dcf-a693-fb9ac01b6c48.jpg" alt="" /> -->
      <div class="wrap pro_txt a-m-c">
        <div class="pro_ser_t fixed">
          <a @click="intelligentSelectionClick" class="fnt_14 more" href="javascript:void(0)"><em>智能选型</em><i
              class="icon-quandian"></i></a>
          <div class="pro_ser_t_inp">
            <input class="fnt_16" @keyup.enter="searchClick" type="text" v-model="form.key" placeholder="请输入产品名称、货号" />
            <button @click="searchClick" class="fnt_20">
              <i class="icon-sousuo"></i>
            </button>
          </div>
        </div>
        <div class="pro_ser_b">
          <p>
            热门搜索：
            <a @click="hotSearchKeywordsClick(item)" href="javascript:void(0)"
              v-for="(item, index) in hotSearchKeywords" :key="index">{{ item.title }}</a>
          </p>
        </div>
      </div>
    </div>

    <div class="product_part">
      <div class="wrap">
        <div class="product_type">
          <dl class="fixed">
            <dt>
              商品分类：<a @click="firstCategoryClick()" href="javascript:void(0)"
                :class="{ active: form.firstCategoryId === '' }">全部</a>
            </dt>
            <dd>
              <a @click="firstCategoryClick(item)" href="javascript:void(0)" v-for="(item, index) in firstCategoryList"
                :key="index" :class="{ active: form.firstCategoryId === item.id }">{{ item.title }}</a>
            </dd>
          </dl>
          <dl class="fixed">
            <dt>
              商品类别：<a @click="secondCategoryClick()" href="javascript:void(0)"
                :class="{ active: form.secondCategoryId === '' }">全部</a>
            </dt>
            <dd>
              <a @click="secondCategoryClick(item)" href="javascript:void(0)"
                v-for="(item, index) in secondCategoryList" :key="index"
                :class="{ active: form.secondCategoryId === item.id }">{{ item.title }}</a>
            </dd>
          </dl>
        </div>
        <div class="product_list" v-if="list && list.length">
          <ul class="fixed">
            <li class="wow fadeInUp" v-for="(item, index) in list" :key="item.id">
              <dl class="fixed">
                <dt class="ratio-img tran_scale" data-ratio="0.6139">
                  <!-- routerLink跳转到详情页，携带参数id -->
                  <router-link :to="{ name: 'product_dets', query: { id: item.id } }">
                    <img :src="item.productImages[0]" :alt="item.title" />
                  </router-link>
                </dt>
                <dd>
                  <router-link :to="{ name: 'product_dets', query: { id: item.id } }">
                    <div class="con">
                      <h3 class="fnt_20 bold">
                        <a href="javascript:void(0)">{{ item.title }}</a>
                      </h3>
                      <p v-if="item.modelNumber">商品型号：{{ item.modelNumber }}</p>
                      <p v-else></p>
                    </div>
                  </router-link>
                  <div class="collection fixed">
                    <div @click="channelCollect(item, index)" :class="item.inFavorites ? 'collect collected' : 'collect'
                      ">
                      <i v-if="!item.inFavorites" class="icon-shoucang"></i>
                      <i v-else-if="item.inFavorites" class="icon-xz"></i>
                      收藏商品
                    </div>
                    <div @click="addCar(item, index, $event)" class="addCar">
                      <i class="icon-3"></i>
                      加入购物车
                    </div>
                  </div>
                </dd>
              </dl>
            </li>
          </ul>
          <div class="pageout">
            <el-pagination :small="isMobile" :hide-on-single-page="value" :pager-count="isMobile ? 3 : 7" background
              @current-change="handleCurrentChange" :current-page="form.page" :page-sizes="[form.size]"
              :page-size="form.size" layout=" prev, pager, next, jumper" :total="total || 0">
            </el-pagination>
          </div>
        </div>
        <div v-else>
          <el-empty :image-size="100"></el-empty>
        </div>
      </div>
    </div>
    <AmendSpecification :amendSpecificationDialog="showModal" :data="modalData" ref="AmendSpecificationRef"
      @amendSpecificationSubData="amendSpecificationSubData" @close="showModal = false" />
    <Footer />
  </div>
</template>
<style scoped lang="less">
.dets_body {
  padding-top: 0;
}

.site_banner {
  .pro_txt {
    max-width: 950rem;

    .pro_ser_t {
      margin-bottom: 25rem;

      .pro_ser_t_inp,
      .pro_ser_t_inp input,
      .pro_ser_t_inp button {
        height: 56rem;
        line-height: 56rem;
        border: none;
        outline: none;
        background: none;
      }

      .pro_ser_t_inp {
        float: right;
        width: calc(100% - 185rem);
        border-radius: 30rem;
        background: #fff;
        overflow: hidden;

        input {
          padding: 0 20rem;
          float: left;
          width: calc(100% - 70rem);
        }

        button {
          cursor: pointer;
          float: right;
          width: 70rem;
          text-align: center;
        }
      }

      a.more {
        float: left;
        height: 56rem;
        line-height: 56rem;
        color: #fff;
        width: 165rem;
        text-align: center;
        margin-top: 0;
        cursor: pointer;
        background: #0160c4;
        background: linear-gradient(90deg,
            rgba(1, 96, 196, 1) 0%,
            rgba(89, 161, 255, 1) 100%);
        border-radius: 30px;

        em {
          margin-right: 20rem;
        }

        i {
          margin-left: 0;
        }
      }
    }

    .pro_ser_b {
      color: #fff;

      a {
        color: #fff;
        margin-right: 15rem;
        padding-right: 15rem;
        position: relative;
        display: inline-block;
      }

      a::after {
        content: "";
        position: absolute;
        right: 0;
        top: 15%;
        width: 1px;
        height: 70%;
        background: #fff;
      }

      a:last-child:after {
        display: none;
      }
    }
  }
}

@media only screen and (min-width: 1025px) {
  .site_banner .pro_txt .pro_ser_t a.more:hover {
    color: #fff !important;
    opacity: 0.9;
  }
}

@media only screen and (max-width: 1023px) {
  .site_banner {
    .pro_txt {
      max-width: 100%;
    }
  }
}

.product_part {
  background: #f8f8f8;
  padding: 60rem 0 125rem;

  .product_type {
    border-radius: 10rem;
    border: 1px solid #d9d9d9;
    background: #fff;

    dl {
      border-bottom: 1px solid #d9d9d9;
      padding: 30rem 35rem 20rem;
    }

    dl:last-child {
      border-bottom: none;
    }

    dt {
      float: left;
      width: 175rem;
      font-weight: bold;

      a {
        color: #40a9e0;
        font-weight: normal;
      }

      a.active {
        color: #008cd6;
        font-weight: bold;
      }
    }

    dd {
      float: right;
      width: calc(100% - 175rem);

      a {
        float: left;
        margin: 0 0 10rem;
        margin-right: 50rem;
      }

      a.active {
        color: #008cd6;
        font-weight: bold;
      }
    }
  }

  .product_list {
    margin-top: 60rem;

    ul {
      margin: 0 -1%;
    }

    li {
      float: left;
      width: 23%;
      margin: 0 1% 60rem;
      background: #fff;
      border-radius: 20rem;
      overflow: hidden;

      dd {
        .con {
          padding: 25rem 35rem 25rem;
        }

        h3 {
          margin-bottom: 20rem;
          line-height: 1.5em;
          height: 3em;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }

        p {
          line-height: 1.5em;
          height: 3em;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }

        .collection {
          padding: 15rem 0rem;
          border-top: 1px solid #d9d9d9;
          position: relative;
          font-weight: bold;

          .collect,
          .addCar {
            float: left;
            width: 50%;
            padding: 10rem 0;
            text-align: center;
            line-height: 20rem;
            cursor: pointer;

            i {
              margin-right: 10rem;
              font-size: 20rem;
              position: relative;
              top: 1rem;
            }
          }

          .collect:hover,
          .addCar:hover {
            color: #40a9e0;
          }

          .collected {
            color: #40a9e0;
          }

          .addCarActive {
            color: #40a9e0;
          }
        }

        .collection::before {
          content: "";
          position: absolute;
          left: 50%;
          top: 15rem;
          width: 1px;
          height: calc(100% - 30rem);
          background: #d9d9d9;
        }
      }
    }
  }
}

@media only screen and (max-width: 1023px) {
  .product_part .product_list li {
    width: 48%;
  }
}

@media only screen and (max-width: 767px) {
  .site_banner {
    .pro_ser_t {
      a.more {
        padding: 0 10rem;
        width: 200rem;
      }

      .pro_ser_t_inp {
        width: calc(100% - 220rem);
      }
    }
  }

  .product_part .product_type dt {
    width: 100%;
    margin-bottom: 10rem;
  }

  .product_part .product_type dd {
    width: 100%;

    a {
      margin-right: 20rem;
    }
  }

  .product_list li {
    width: 98%;
  }

  // .pageout {
  //   display: none;
  // }
  .product_part,
  .pro_ser_b {
    font-size: 14px;
  }

  .product_part .product_type dd a {
    margin-right: 20px;
  }

  .pageout .el-pagination {
    text-align: center;
  }

  .pageout .el-pagination .btn-prev,
  .pageout .el-pagination .btn-next,
  .pageout .el-pagination .el-pager li {
    min-width: 32px;
    height: 32px;
    margin: 0 4px;
    font-size: 14px;
  }
}

.product_part .product_list li dt a {
  display: block;
  height: 0;
  position: relative;
  padding-bottom: 59.5%;
}

.product_part .product_list li dt a img {
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  position: absolute;
  left: 50%;
  top: 50%;
}

@media only screen and (max-width: 767px) {
  .product_part .product_list ul {
    display: flex;
    flex-wrap: wrap;
  }

  .product_part .product_list li {
    float: none;
    width: 48%;
  }

  .product_part .product_list li dd h3,
  .product_part .product_list li dd p {
    height: auto;
    min-height: 3em;
  }

  .product_part .product_list li {
    margin-bottom: 20px;
  }

  .product_part .product_list li dd .collection .collect,
  .product_part .product_list li dd .collection .addCar {
    line-height: 15px;
    font-size: 10px;
  }

  .product_part .product_list li dd .collection .collect i,
  .product_part .product_list li dd .collection .addCar i {
    font-size: 10px;
    margin-right: 0;
  }

  .site_banner .pro_txt .pro_ser_t .pro_ser_t_inp {
    width: calc(100% - 220rem);
  }

  .site_banner .pro_txt .pro_ser_t a.more {
    width: 200rem;
  }
}
</style>
<script>
import { memberTeamPageList, getUserInfo } from "@/api/member"; //会员中心接口
import {
  getProductList,
  getProductCategory,
  hotSearchKeywords,
  addFavorite,
  deleteFavorite,
  findByProductId,
  addCartCart,
  shoppingCartGetCount,
  deleteCartCart,
  findCartCart,
} from "@/api/product";
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import bannerImg from "../../temp/images/product_banner.jpg";
import screenSize from "@/tool/screenSize";
import AmendSpecification from "@/components/amendSpecification.vue"; //产品规格弹窗
import { setWithExpiry, getWithExpiry } from '@/utils/storage-ttl'; // 本地存储加时效性封装文件
import Bus from "@/utils/bus";
export default {
  mixins: [screenSize],
  name: "product",
  computed: {
    // 根据是否移动端返回分页尺寸
    paginationSize() {
      return this.isMobile ? true : false;
    },
  },
  components: {
    Header,
    Footer,
    AmendSpecification,
  },
  data() {
    return {
      bannerImg,
      msg: "list",
      isLogin: false,
      form: {
        firstCategoryId: "", //一级分类id
        secondCategoryId: "", //二级分类id
        key: "", //搜索关键词
        page: 1,
        size: 12,
      },
      value: true, //true当只有一页时隐藏分页
      total: 0, //产品总数
      hotSearchKeywords: [], //热门搜索词
      firstCategoryList: [], //一级商品分类列表
      secondCategoryList: [], //二级商品分类列表
      categoryList: [], //一级和二级放在一起，方便页面循环
      collectFlag: false,
      list: [],

      cartCount: 0, //购物车飞车数量
      // 自定义其他角标
      customBadges: {
        service: 0, // 客服角标
        compare: 0, // 对比角标
      },

      // 加入购物车表单
      addCarForm: {
        isQuickOrder: false, //是否快速下单
        productId: null, //商品id
        quantity: null, //数量
        specifications: "", //购买规格一级Id
        specificationsTwo: "", //购买规格二级Id
      },

      addCarEvent: null, //当前选中的购物车

      showModal: false, // 控制规格弹窗显示
      modalData: "", // 要传递给规格弹窗的数据

      basicInfo: JSON.parse(localStorage.getItem("basicInfo")) || {}, //获取基础信息
      userInfo: null, //获取用户基本信息（登录以后）

      isAtTop: true, // 初始滚动条在顶部
    };
  },
  created() { },
  watch: {
    $route(to, from) {
      // 当路由变化时（如 query 或 params 改变），重新获取数据
      if (this.$route.query.key) {
        this.form.key = decodeURIComponent(this.$route.query.key);
      }

      if (this.$route.query.firstCategoryId || this.$route.query.secondCategoryId) {
        this.init();
      } else {
        this.init();
        this.getProductListFun();
      }
    },
  },
  mounted() {
    if (this.$route.query.key) {
      this.form.key = decodeURIComponent(this.$route.query.key);
    }
    if (this.$route.query.firstCategoryId || this.$route.query.secondCategoryId) {
      this.init();
    } else {
      this.init();
      this.getProductListFun();
    }

    this.checkScrollTop(); // 初始化检查
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 获取基础信息
    async init() {
      // 获取热门搜索词
      hotSearchKeywords({ page: 1, size: 20 }).then((res) => {
        this.hotSearchKeywords = [];
        res.content.forEach((item) => {
          this.hotSearchKeywords.push({
            id: item.id,
            title: item.title,
            url: item.url,
            relationId: item.relationId,
          });
        });
      });

      if (getWithExpiry('logInInfo')) {
        // 获取用户基本信息
        await getUserInfo().then((res) => {
          this.userInfo = res;
        });
      }

      // 获取商品分类
      await getProductCategory().then((res) => {
        this.secondCategoryList = [];
        this.firstCategoryList = res;
        res.forEach((item) => {
          if (item.child.length > 0) {
            item.child.forEach((itemOne) => {
              this.secondCategoryList.push({
                title: itemOne.title,
                id: itemOne.id,
                firstCategoryId: item.id,
                firstCategoryTitle: item.title,
              });
            });
          }
        });
        if (this.$route.query.secondCategoryId) {
          this.firstCategoryList.forEach((itemOne) => {
            if (this.$route.query.firstCategoryId == itemOne.id) {
              this.secondCategoryList = [];
              itemOne.child.forEach((item) => {
                this.secondCategoryList.push({
                  title: item.title,
                  id: item.id,
                  firstCategoryId: itemOne.id,
                  firstCategoryTitle: itemOne.title,
                });
              });
            }
          });

          const secondCategoryIdUrl = this.$route.query.secondCategoryId;
          const secondCategoryIdCategory = this.secondCategoryList.find(
            (item) => item.id == secondCategoryIdUrl,
          );
          if (secondCategoryIdCategory) {
            this.secondCategoryFun(secondCategoryIdCategory);
          }
        } else {
          if (this.$route.query.firstCategoryId) {
            const targetId = this.$route.query.firstCategoryId;
            const category = this.firstCategoryList.find(
              (item) => item.id == targetId,
            );
            if (category) {
              this.firstCategoryFun(category);
            }
          }
        }

        // const targetId = this.$route.query.firstCategoryId;
        // const category = this.firstCategoryList.find(
        //   (item) => item.id == targetId,
        // );
        // if (category) {
        //   this.firstCategoryFun(category);
        // }
      });

      this.categoryList.push(this.firstCategoryList, this.secondCategoryList);
    },

    // 获取商品列表
    getProductListFun() {
      getProductList(this.form).then((res) => {
        this.list = res.content;
        this.total = res.totalElements;
      });
    },

    // 搜索点击事件
    searchClick() {
      // if (this.form.key == '') {
      //   this.$message.error('请输入搜索内容')
      //   return
      // }else{
      this.form.page = 1;
      this.getProductListFun();
      // }
    },

    // 热门搜索点击事件
    hotSearchKeywordsClick(item) {
      if (item.url) {
        window.location.href = item.url;
      } else {
        this.form.key = item.title;
        this.getProductListFun();
      }
    },

    // 分页改变事件
    handleCurrentChange(val) {
      this.form.page = val;
      this.getProductListFun();
    },

    // 一级分类点击事件
    firstCategoryClick(item) {
      if (item) {
        this.$router.push({
          path: "/product",
          query: {
            firstCategoryId: item.id,
          },
        });
      } else {
        this.form.firstCategoryId = "";
        this.form.secondCategoryId = "";
        this.$router.push({
          path: "/product",
        });
      }
    },

    // 二级分类点击事件
    secondCategoryClick(item) {
      if (item) {
        this.firstCategoryList.forEach((itemOne) => {
          if (item.id == itemOne.id) {
            this.secondCategoryList = [];
            itemOne.child.forEach((item) => {
              this.secondCategoryList.push({
                title: item.title,
                id: item.id,
                firstCategoryId: item.id,
                firstCategoryTitle: item.title,
              });
            });
          }
        });

        this.$router.push({
          path: "/product",
          query: {
            firstCategoryId: item.firstCategoryId,
            secondCategoryId: item.id,
          },
        });
      } else {
        this.form.secondCategoryId = "";
        if (this.$route.query.firstCategoryId) {
          this.$router.push({
            path: "/product",
            query: {
              firstCategoryId: this.$route.query.firstCategoryId
            },
          });
        } else {
          this.form.firstCategoryId = "";
          this.$router.push({
            path: "/product",
          });
        }
      }
    },

    //一级分类点击事件函数
    firstCategoryFun(item) {
      this.form.page = 1;
      if (item) {
        //某个一级分类
        this.firstCategoryList.forEach((itemOne) => {
          if (item.id == itemOne.id) {
            this.secondCategoryList = [];
            itemOne.child.forEach((itemTow) => {
              this.secondCategoryList.push({
                title: itemTow.title,
                id: itemTow.id,
                firstCategoryId: item.id,
                firstCategoryTitle: item.title,
              });
            });
          }
        });
        this.form.secondCategoryId = "";
        this.form.firstCategoryId = item.id;
        this.getProductListFun();
      } else {
        //全部分类
        this.form.firstCategoryId = "";
        this.form.secondCategoryId = "";
        this.init();
        this.getProductListFun();
      }
    },

    // 二级分类点击事件函数
    secondCategoryFun(item) {
      this.form.page = 1;
      if (item) {
        //某个二级分类
        if (this.$route.query.secondCategoryId) {
          this.form.firstCategoryId = item.firstCategoryId;
        }
        this.form.secondCategoryId = item.id;
        this.getProductListFun();
      } else {
        //全部二级分类
        this.form.secondCategoryId = "";
        this.init();
        this.getProductListFun();
      }
    },

    // 收藏点击事件
    channelCollect(item, index) {
      if (getWithExpiry('logInInfo')) {
        // 获取收藏状态
        findByProductId({ id: item.id }).then((res) => {
          if (res == false) {
            //收藏
            addFavorite({ productId: item.id }).then((res) => {
              this.$message.success("收藏成功");
              this.getProductListFun();
            });
          } else {
            //取消收藏
            deleteFavorite({ id: item.favoritesDTO.id }).then((res) => {
              this.$message.success("取消收藏成功");
              this.getProductListFun();
            });
          }
        });
      } else {
        this.$confirm("当前尚未登录，是否前往登录?", "提示", {
          confirmButtonText: "去登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/signup/login");
          })
          .catch(() => { });
      }
    },

    // 规格弹窗确认后的数据
    amendSpecificationSubData(data) {
      this.addCarForm.quantity = data.quantity;
      this.addCarForm.specifications = data.specification;
      this.addCarForm.specificationsTwo = data.specificationsTwo;
      this.showModal = false;
      addCartCart(this.addCarForm).then((res) => {
        shoppingCartGetCount().then((res) => {
          //获取购物车数量
          this.cartCount = res;
          this.$message.success("加入购物车成功");
          Bus.$emit("sendData", {
            cartCount: this.cartCount,
            customBadges: this.customBadges,
            target: this.addCarEvent.target,
          });
        });
      });
    },

    // 加入购物车
    addCar(item, index, e) {
      if (getWithExpiry('logInInfo')) {
        if (this.userInfo.isVerified) {
          //判断是否认证
          this.addCarEvent = e;
          // 设置要传递的数据
          this.modalData = {
            title: "规格",
            item: item,
          };
          // 显示弹窗
          this.showModal = true;
          this.addCarForm.productId = item.id;
          this.$refs.AmendSpecificationRef.receiveData(this.modalData);
        } else {
          this.$confirm("是否前往认证?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$router.push({ path: "/member/index" });
            })
            .catch(() => { });
        }
      } else {
        this.$confirm("当前尚未登录，是否前往登录?", "提示", {
          confirmButtonText: "去登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/signup/login");
          })
          .catch(() => { });
      }
    },

    // 智能选型点击事件
    intelligentSelectionClick() {
      this.$router.push({ path: "/product/intelligentSelect" });
    },

    handleScroll() {
      // 使用 requestAnimationFrame 优化性能
      requestAnimationFrame(() => {
        this.checkScrollTop();
      });
    },
    checkScrollTop() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      this.isAtTop = scrollTop === 0;
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
